import { render, staticRenderFns } from "./WarehousePackaging.vue?vue&type=template&id=72dbedbc&scoped=true&"
import script from "./WarehousePackaging_.js?vue&type=script&lang=js&"
export * from "./WarehousePackaging_.js?vue&type=script&lang=js&"
import style0 from "./WarehousePackaging.vue?vue&type=style&index=0&id=72dbedbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dbedbc",
  null
  
)

export default component.exports